import React from "react";
import { CreditState } from "../stores/credit/credit-state.interface";
import { useCreditSelector } from "../stores/product/product.store";

interface BackArrowProps {
    onClick?: () => void;
}

export const BackArrow: React.FC<BackArrowProps> = ({ onClick }) => {
    const translateText = useCreditSelector((state: CreditState) => state.text);

    const click = () => {
        if(onClick) onClick();
    }

    return (
        <div className="inline-block">
            <div className="flex items-center cursor-pointer mb-2" onClick={ () => click() }>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M10.6306 17.5426C10.8889 17.7969 11.3029 17.7982 11.5628 17.5457L11.6539 17.4572C11.9222 17.1966 11.9236 16.7663 11.657 16.5039L7.82993 12.7366H18.3333C18.7015 12.7366 19 12.4381 19 12.0699V11.9301C19 11.5619 18.7015 11.2634 18.3333 11.2634H7.82993L11.6587 7.50634C11.9247 7.2453 11.9251 6.81686 11.6595 6.5554L11.5629 6.46037C11.3034 6.20495 10.887 6.20495 10.6276 6.46037L5 12L10.6306 17.5426Z"
                        fill="#8D8D8D"/>
                </svg>
                <span className="text-sm">{ translateText.back }</span>
            </div>
        </div>
    )
}